import escapeHtml from 'escape-html';

export default function serializeHtmlText(node) {
  let string = escapeHtml(node.text);

  // We don't need to wrap empty strings in marks.. this also messes with the empty paragraph
  // logic that makes <div><br></div> since it expects an empty string, not an awkwardly empty
  // <b><u></u></b> for example.
  if (!string) {
    return string;
  }

  if (node.bold) {
    string = `<b>${string}</b>`;
  }
  if (node.italic) {
    string = `<i>${string}</i>`;
  }
  if (node.underline) {
    string = `<u>${string}</u>`;
  }
  return string;
}
